import React from 'react'
import { usePage } from 'hooks'
import Header from 'components/app/Header'
import Breadcrumb from 'components/app/Breadcrumb'
import PageBody from 'components/app/PageBody'
import CompaniesContainer from 'components/company/list/CompaniesContainer'
import CompaniesHeader from 'components/company/list/CompaniesHeader'

export default function CompaniesPage() {
  const { header } = usePage()

  return (
    <PageBody
      renderHeader={() => (
        <>
          <Header>
            <Breadcrumb crumbs={header?.crumbs} />
          </Header>
          <CompaniesHeader />
        </>
      )}
      renderContent={() => <CompaniesContainer />}
    />
  )
}
